import * as React from 'react';
import { useTranslation } from 'react-i18next';

import RootSeatInfoGroup from '@websky/core/src/SeatMap/components/SeatsInfo/SeatInfoGroup/SeatInfoGroup';
import SeatInfo from '@websky/core/src/SeatMap/components/SeatsInfo/SeatInfo/SeatInfo';
import { GdsSeatService } from '@websky/core/src/SeatMap/types';
import { useTheme } from '@websky/core/src/theme';

const SeatInfoGroup: typeof RootSeatInfoGroup = props => {
	const { t } = useTranslation('SeatMap');
	const theme = useTheme('SeatMap').SeatsInfoStyles;

	const getSeatKey = (service: GdsSeatService) => `${service.id}_${service.rfisc}`;

	const groupedSeatsInfo = React.useMemo(() => {
		const seatsMap = new Map<string, GdsSeatService>();

		props.seatService.forEach(service => {
			const key = getSeatKey(service);

			if (!seatsMap.has(key)) {
				seatsMap.set(key, service);
			}
		});

		return [...seatsMap.values()];
	}, [props.seatService]);

	const renderTitle = (service: GdsSeatService) => {
		const title = t(getSeatKey(service), {
			defaultValue: t(service.comfort, { defaultValue: service.name })
		});

		return (
			<div className={theme.header}>
				<div className={theme.title} data-rfisc={service.rfisc}>
					{title}
				</div>
			</div>
		);
	};

	return (
		<>
			{groupedSeatsInfo.map(seat => (
				<SeatInfo
					key={getSeatKey(seat)}
					seatService={seat}
					amenities={props.amenities}
					fullInfo={props.fullInfo}
					hideImage={props.hideImage}
					services={props.services}
					passengerId={props.passengerId}
					segmentId={props.segmentId}
					renderHeader={() => renderTitle(seat)}
				/>
			))}
		</>
	);
};

export default SeatInfoGroup;
